import React, { Component } from "react";
import CartContext from "./CartContext.js";
import { OrderSummaryPOS } from "./OrderSummaryPOS.js";
import CheckoutPOS from "./CheckoutPOS.js";
import { Navbar, Nav, Row, Col } from "react-bootstrap";

export default class BottomSummaryPOS extends Component {
  static contextType = CartContext;

  render() {
    const bg = this.context.posBackgroundColor || "white";
    const isDesktop = window.innerWidth > 900;

    return (
      <>
        <div
          className="fixed-bottom m-0 p-0"
          style={{
            backgroundColor: bg,
            // Ensure the footer itself respects iOS safe area
            paddingBottom: "env(safe-area-inset-bottom)",
          }}
        >
          {isDesktop ? (
            // ===== Desktop: Summary (left) + Checkout (right) in a single bar =====
            <Navbar
              className="position-sticky fixed-bottom m-0 p-0 border "
              style={{
                fontFamily: "Tahoma",
                color: "navy",
                backgroundColor: bg,
              }}
            >
              <Navbar.Collapse className="justify-content-start m-0 p-1 border-0 border-dark w-100">
                <Row className="w-100 m-0 p-0">
                  <Col sm={7} className="m-0 p-0">
                    <Nav className="w-100 m-0 p-0">
                      <OrderSummaryPOS
                        myCart={this.context.getPOSCartByName(
                          this.context.selectedPOS
                        )}
                        StoreCouponDetails={this.props.StoreCouponDetails}
                      />
                    </Nav>
                  </Col>
                  <Col sm={5} className="m-0 p-0">
                    <CheckoutPOS
                      StoreCouponDetails={this.props.StoreCouponDetails}
                      coupon={this.props.coupon}
                      quickPayEventKey={this.props.quickPayEventKey}
                      quickPayEventSent={this.props.quickPayEventSent}
                      SetQuickPayEventFalse={this.props.SetQuickPayEventFalse}
                      orderTypeOrderDelivered={
                        this.props.orderTypeOrderDelivered
                      }
                      orderTypeTakeAway={this.props.orderTypeTakeAway}
                      orderTypeHomeDelivery={this.props.orderTypeHomeDelivery}
                    />
                  </Col>
                </Row>
              </Navbar.Collapse>
            </Navbar>
          ) : (
            // ===== Mobile: Single footer with two stacked rows (no double navbars) =====
            <Navbar
              className="position-sticky fixed-bottom m-0 p-0 border-0"
              style={{
                fontFamily: "Tahoma",
                color: "navy",
                backgroundColor: bg,
              }}
            >
              <div className="w-100">
                {/* Order summary (compact) */}
                <div className="m-0 p-0">
                  <OrderSummaryPOS
                    myCart={this.context.getPOSCartByName(
                      this.context.selectedPOS
                    )}
                    StoreCouponDetails={this.props.StoreCouponDetails}
                  />
                </div>

                {/* Checkout actions */}
                <div className="m-0 p-2">
                  <CheckoutPOS
                    StoreCouponDetails={this.props.StoreCouponDetails}
                    coupon={this.props.coupon}
                    quickPayEventKey={this.props.quickPayEventKey}
                    quickPayEventSent={this.props.quickPayEventSent}
                    SetQuickPayEventFalse={this.props.SetQuickPayEventFalse}
                    orderTypeOrderDelivered={this.props.orderTypeOrderDelivered}
                    orderTypeTakeAway={this.props.orderTypeTakeAway}
                    orderTypeHomeDelivery={this.props.orderTypeHomeDelivery}
                  />
                </div>
              </div>
            </Navbar>
          )}
        </div>
      </>
    );
  }
}
